import {read} from "@/api/rest";

const requestType = {
  index: async () => await read('/request-type'),
};

export default requestType;